import svg4everybody from 'svg4everybody';

jQuery(document).ready(function($) {

	$.misc = {
		init: function() {
			svg4everybody();

			$('img').removeAttr('title');

			// $.misc.start();
			$.misc.social();
			$.misc.youtube();
			$.misc.dateinput();
			$.misc.anchorInit();
			$.misc.paginationBackToTop();
		},

		start: function() {
			$('table').cardtable({
				myClass: 'm-table__responsive' +
					''
			});
		},

		social: function() {
			// open
			$('.m-sharer__social').on('click', function() {
				$('.m-sharer__social-box').toggleClass('active');

				if ($('.m-sharer__social-box').hasClass('active')) {
					// opened
					$('#m-sharer-box').attr('aria-hidden', false);
					$(this).attr('aria-expanded', true);

					$(document).on('keydown', function (e) {
						if (e.keyCode === 27) { // ESC
							$('.m-sharer__social-box').removeClass('active');
							$('#m-sharer-box').attr('aria-hidden', true);
							$(this).attr('aria-expanded', false);
							$('.m-sharer__social').focus();
						}
					});
				} else {
					// closed
					$('#m-sharer-box').attr('aria-hidden', true);
					$(this).attr('aria-expanded', false);
				}
			});

			// close
			$('.m-sharer__social-close').on('click', function() {
				$('.m-sharer__social-box').toggleClass('active');

				if (!$('.m-sharer__social-box').hasClass('active')) {
					$('#m-sharer-box').attr('aria-hidden', true);
					$('.m-sharer__social').attr('aria-expanded', false);
				}
			});
		},

		youtube: function() {
			$(document).on('click', '[data-youtube]', function() {
				$(this).find('.a-mediabox__youtube_text').show();
				$(this).find('.a-mediabox__youtube_text').attr('aria-hidden', false);

				$(this).addClass('y-hint-loaded');
				$(this).find('.a-mediabox__youtube_preview').attr('aria-expanded', true);
			});

			$('body').on('click', '.a-mediabox__youtube_text', function(e) {
				if (!$(e.target).is('.a-mediabox__youtube_policies')) {

					e.stopPropagation();
					e.preventDefault();
				
					// stop other videos
					$('[data-youtube] iframe').each(function() {
						$(this)[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
					});

					// load youtube video
					let iframe = $(document.createElement('iframe'));

					iframe.attr('src', $(this).parents('.y-hint-loaded').attr('data-youtube'));
					iframe.attr('allow', 'autoplay');
					iframe.attr('allowfullscreen', 'true');
					
					$(this).parents('.js-video-loader').append(iframe);

					// $(this).parents('.js-video-loader').removeClass('y-hint-loaded');
					$(this).remove();

				}
			});
		},

		dateinput: function() {
			$('#wdgt_date_picker').change(function() {
				let inputDateArray = $('#wdgt_date_picker').val().split('-');
				let dateFormatted = inputDateArray[2] + '.' + inputDateArray[1] + '.' + inputDateArray[0];

				$('#wdgt_date').val(dateFormatted);
			});
		},

		anchorInit: function() {
			$('.m-anchors__preload-hider').appendTo('.m-anchors__preload-spacer');
			$('.m-anchors__preload-hider').removeClass('m-anchors__preload-hider');
			$('.m-anchors__preload-spacer').removeClass('m-anchors__preload-spacer');
		},

		paginationBackToTop: function() {
			$(document).on('click', '.pager__item', function() {
				const filterPosition = $('.m-event-filter').offset();
				$('html, body').animate({ scrollTop: filterPosition.top }, 700);
			});
		},
	}

});
